// extracted by mini-css-extract-plugin
module.exports = {"h3":"OppositeArchetype_h3__pWAT_","wrapper":"OppositeArchetype_wrapper___sxEE","arrowsDiv":"OppositeArchetype_arrowsDiv__5Fj_I"};